import React from "react";
import "../../Assets/style/components/chat.scss";
import {} from "../../Redux/Actions/actions";
import { connect } from "react-redux";
import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import { useOutletContext } from "react-router-dom";
// Component
import Contactlist from "../../Components/chat-components/Contact-list-component/Contact-list.component";
import ChatComponent from "../../Components/chat-components/Chat-component/Chat.component";

const StyledPaper = styled(Paper)(({ theme }) => ({
  height: "100%",
  width: "100%",
}));

const mapStateToProps = (state) => {
  return {
    chat: state.data.chat,
    CustomerDetailsShow: state.data.CustomerDetailsShow,
    userlistshow: state.data.userlistshow,
    showExternalChat: state.data.showExternalChat,
  };
};

const Chat = (props) => {
  const [callObj2, callmap, playMsgTone, stopwatch1, stopwatch2, aesSocket] =
    useOutletContext();
  return (
    <StyledPaper elevation={0} sx={{ background: "#EEF7FF", padding: "0" }}>
      <Stack
        sx={{ height: "100%", width: "100%" }}
        direction={"row"}
        spacing={0.5}
      >
        <Contactlist />
        <ChatComponent
          playMsgTone={playMsgTone}
          stopwatch1={stopwatch1}
          stopwatch2={stopwatch2}
          aesSocket={aesSocket}
        />
      </Stack>
    </StyledPaper>
  );
};

export default connect(mapStateToProps, {})(Chat);
